import {
  OfferNetworkProvider,
  OfferPlacementSurface,
} from "@redotech/redo-integrations-definitions-common/offer-network/offer-placement";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const resolvedRoktOfferConfigSchema_ = z.object({
  provider: z.literal(OfferNetworkProvider.ROKT),
  accountId: z.string(),
  pageIdentifier: z.string(),
  sandbox: z.boolean(),
});
const resolvedFalconOfferConfigSchema_ = z.object({
  provider: z.literal(OfferNetworkProvider.FALCON),
  /** The publisher public key (falcon_pub_...) — client-safe by design. */
  apiKey: z.string(),
  placementId: z.string(),
  isLiveMode: z.boolean(),
});

/** Client-safe, render-ready SDK config resolved server-side. */
const resolvedOfferConfigSchema_ = z.discriminatedUnion("provider", [
  resolvedRoktOfferConfigSchema_,
  resolvedFalconOfferConfigSchema_,
]);
export type ResolvedOfferConfig =
  | z.infer<typeof resolvedRoktOfferConfigSchema_>
  | z.infer<typeof resolvedFalconOfferConfigSchema_>;
export const resolvedOfferConfigSchema: z.ZodType<ResolvedOfferConfig> =
  resolvedOfferConfigSchema_;

const offerPlacementSummarySchema_ = z.object({
  id: z.string(),
  provider: createEnum(Object.values(OfferNetworkProvider)),
  name: z.string(),
  surface: createEnum(Object.values(OfferPlacementSurface)),
  config: resolvedOfferConfigSchema_,
});
export type OfferPlacementSummary = z.infer<
  typeof offerPlacementSummarySchema_
>;
export const offerPlacementSummarySchema: z.ZodType<OfferPlacementSummary> =
  offerPlacementSummarySchema_;
